import {CLIENT_VERSION_HTTP_HEADER, getClientVersion} from '@github-ui/client-version'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {getFetchNonceHeaders} from '@github-ui/fetch-nonce'
import {isUIService} from '@github-ui/runtime-environment'

const UI_SERVICE_HEADER = 'X-GitHub-UI-Service'

export function getBaseFetchHeaders(nonceToValidate?: string) {
  let headers: HeadersInit = {
    'X-Requested-With': 'XMLHttpRequest',
    ...getFetchNonceHeaders(nonceToValidate),
    ...(isUIService && isFeatureEnabled('ui_service_referrer_metrics') ? {[UI_SERVICE_HEADER]: 'true'} : {}),
  }

  headers = {
    ...headers,
    [CLIENT_VERSION_HTTP_HEADER]: getClientVersion(),
  }

  return headers
}

export function addBaseFetchHeaders(headers: Headers, nonceToValidate?: string) {
  const fetchHeaders = getBaseFetchHeaders(nonceToValidate)

  for (const [header, value] of Object.entries(fetchHeaders)) {
    headers.set(header, value)
  }
}

export function getAppTypeHeader(appType: 'navigator' | 'dataRouter'): HeadersInit {
  return {'X-GitHub-App-Type': appType}
}
